var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Dados do proprietário" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("validation-provider", {
            attrs: {
              rules: "required",
              mode: "lazy",
              name: _vm.nomeAba + "/Nome completo"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 13 } },
                      [
                        _c("Label", {
                          attrs: { label: "Nome completo", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Nome completo",
                            placeholder: "Digite seu nome completo",
                            clearable: ""
                          },
                          model: {
                            value: _vm.pessoaFisica.nome,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "nome", $$v)
                            },
                            expression: "pessoaFisica.nome"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("validation-provider", {
            attrs: {
              rules: "required|cpf",
              mode: "lazy",
              name: _vm.nomeAba + "/CPF"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("Label", {
                          attrs: { label: "CPF", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "CPF",
                            placeholder: "000.000.000-00",
                            clearable: "",
                            disabled: _vm.hasProcesso
                          },
                          model: {
                            value: _vm.pessoaFisica.cpf,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "cpf", $$v)
                            },
                            expression: "pessoaFisica.cpf"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "ml-forms", attrs: { span: 6 } },
            [
              _c("Label", { attrs: { label: "RG", obrigatorio: false } }),
              _vm._v(" "),
              _c("el-input", {
                attrs: { name: "RG", maxlength: "12", clearable: "" },
                model: {
                  value: _vm.pessoaFisica.rg,
                  callback: function($$v) {
                    _vm.$set(_vm.pessoaFisica, "rg", $$v)
                  },
                  expression: "pessoaFisica.rg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputSelect", {
            attrs: {
              label: "Sexo",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              opcoes: _vm.opcoesSexo,
              widthColumn: 6,
              rulesInput: "required"
            },
            model: {
              value: _vm.pessoaFisica.sexo,
              callback: function($$v) {
                _vm.$set(_vm.pessoaFisica, "sexo", $$v)
              },
              expression: "pessoaFisica.sexo"
            }
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: "required",
              mode: "lazy",
              name: _vm.nomeAba + "/Data de nascimento"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { staticClass: "ml-forms", attrs: { span: 6 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Data de nascimento",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##/##/####",
                              expression: "'##/##/####'"
                            }
                          ],
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            format: "dd/MM/yyyy",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.options,
                            placeholder: "__/__/____",
                            clearable: ""
                          },
                          model: {
                            value: _vm.pessoaFisica.dataNascimento,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "dataNascimento", $$v)
                            },
                            expression: "pessoaFisica.dataNascimento"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("UFMunicipio", {
            attrs: {
              nomeAba: _vm.nomeAba,
              UF: _vm.proprietario.pessoaFisica.naturalidade.codigoEstado,
              municipioNome: _vm.proprietario.pessoaFisica.naturalidade.nome,
              municipioId: _vm.proprietario.pessoaFisica.naturalidade.id,
              ufObrigatorio: true,
              municipioObrigatorio: true
            },
            on: {
              "update:UF": function($event) {
                return _vm.$set(
                  _vm.proprietario.pessoaFisica.naturalidade,
                  "codigoEstado",
                  $event
                )
              },
              "update:u-f": function($event) {
                return _vm.$set(
                  _vm.proprietario.pessoaFisica.naturalidade,
                  "codigoEstado",
                  $event
                )
              },
              "update:municipioNome": function($event) {
                return _vm.$set(
                  _vm.proprietario.pessoaFisica.naturalidade,
                  "nome",
                  $event
                )
              },
              "update:municipio-nome": function($event) {
                return _vm.$set(
                  _vm.proprietario.pessoaFisica.naturalidade,
                  "nome",
                  $event
                )
              },
              "update:municipioId": function($event) {
                return _vm.$set(
                  _vm.proprietario.pessoaFisica.naturalidade,
                  "id",
                  $event
                )
              },
              "update:municipio-id": function($event) {
                return _vm.$set(
                  _vm.proprietario.pessoaFisica.naturalidade,
                  "id",
                  $event
                )
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Contatos", {
        attrs: {
          emails: _vm.proprietario.emails,
          telefones: _vm.proprietario.telefones,
          observer: _vm.observer,
          nomeAba: _vm.nomeAba
        },
        on: {
          "update:emails": function($event) {
            return _vm.$set(_vm.proprietario, "emails", $event)
          },
          "update:telefones": function($event) {
            return _vm.$set(_vm.proprietario, "telefones", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("DadosConjuge", {
        attrs: {
          nomeAba: _vm.nomeAba,
          estadoCivil: _vm.pessoaFisica.estadoCivil,
          rendaFamiliar: _vm.pessoaFisica.rendaFamiliar,
          nome: _vm.conjuge.pessoaFisica.nome,
          regimeBens: _vm.conjuge.pessoaFisica.regimeBens,
          cpf: _vm.conjuge.pessoaFisica.cpf,
          sexo: _vm.conjuge.pessoaFisica.sexo,
          municipioId: _vm.conjuge.pessoaFisica.naturalidade.id,
          municipioNome: _vm.conjuge.pessoaFisica.naturalidade.nome,
          UF: _vm.conjuge.pessoaFisica.naturalidade.codigoEstado
        },
        on: {
          "update:estadoCivil": function($event) {
            return _vm.$set(_vm.pessoaFisica, "estadoCivil", $event)
          },
          "update:estado-civil": function($event) {
            return _vm.$set(_vm.pessoaFisica, "estadoCivil", $event)
          },
          "update:rendaFamiliar": function($event) {
            return _vm.$set(_vm.pessoaFisica, "rendaFamiliar", $event)
          },
          "update:renda-familiar": function($event) {
            return _vm.$set(_vm.pessoaFisica, "rendaFamiliar", $event)
          },
          "update:nome": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica, "nome", $event)
          },
          "update:regimeBens": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica, "regimeBens", $event)
          },
          "update:regime-bens": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica, "regimeBens", $event)
          },
          "update:cpf": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica, "cpf", $event)
          },
          "update:sexo": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica, "sexo", $event)
          },
          "update:municipioId": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica.naturalidade, "id", $event)
          },
          "update:municipio-id": function($event) {
            return _vm.$set(_vm.conjuge.pessoaFisica.naturalidade, "id", $event)
          },
          "update:municipioNome": function($event) {
            return _vm.$set(
              _vm.conjuge.pessoaFisica.naturalidade,
              "nome",
              $event
            )
          },
          "update:municipio-nome": function($event) {
            return _vm.$set(
              _vm.conjuge.pessoaFisica.naturalidade,
              "nome",
              $event
            )
          },
          "update:UF": function($event) {
            return _vm.$set(
              _vm.conjuge.pessoaFisica.naturalidade,
              "codigoEstado",
              $event
            )
          },
          "update:u-f": function($event) {
            return _vm.$set(
              _vm.conjuge.pessoaFisica.naturalidade,
              "codigoEstado",
              $event
            )
          }
        }
      }),
      _vm._v(" "),
      _c("Endereco", {
        attrs: {
          endereco: _vm.cadastro.proprietario.pessoa.enderecoCorrespondencia,
          nomeAba: _vm.nomeAba
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03ac0238", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ac0238","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/proprietario/proprietario.vue
// module id = null
// module chunks = 